/**
 * 联系人管理标签数据接口文档
 */
import { Method } from '../core';
import { API, SOURCE } from '../config';

const api = API;

export default {
  // 获取合同
  getDocInfos: {
    url: `${api}/rest/v1/signflow/batch/docInfos`,
    method: Method.POST,
    body: {
      participantList: {
        $type: [Array]
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 获取印章详情列表
  getSealList: {
    url: `${api}/rest/v1/seal/list/detail`,
    method: Method.GET,
    body: {
      page: {
        $type: Number,
        $required: true
      },
      pageSize: {
        $type: Number,
        $required: true
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 获取授权印章
  getGrantSealList: {
    url: `${api}/rest/v1/seal/grant/list`,
    method: Method.GET,
    body: {
      page: {
        $type: Number,
        $required: true
      },
      pageSize: {
        $type: Number,
        $required: true
      },
      needCert: {
        $type: Boolean
      },
      accountUid: {
        $type: String
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 云证书批量签署
  cloudSign: {
    url: `${api}/rest/v1/cloudSign/batch`,
    method: Method.POST,
    body: {
      participantIdList: {
        $type: [String, Array]
      },
      posArray: {
        $type: Array
      },
      positioned: {
        $type: Number
      },
      validateType: {
        $type: Number
      },
      code: {
        $type: String
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 发送验证码
  sendCode: {
    url: `${api}/rest/v1/code/send`,
    method: Method.POST,
    body: {
      account: {
        $type: String
      },
      type: {
        $type: Number
      },
      flowIdList: {
        $type: [String, Array]
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 校验验证码
  validateCode: {
    url: `${api}/rest/v1/code/validate`,
    method: Method.POST,
    body: {
      account: {
        $type: String
      },
      code: {
        $type: String
      },
      type: {
        $type: Number
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // 查看ukey列表
  getUkeyList: {
    url: `${api}/rest/v1/accountcert/list`,
    method: Method.GET,
    body: {
      page: {
        $type: Number
      },
      pageSize: {
        $type: Number
      },
      type: {
        $type: Number
      },
      accountId: {
        $type: Number
      },
      accountUid: {
        $type: String
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  },
  // ukey签署合成
  batchMerge: {
    url: `${api}/rest/v1/ukeySign/batch/merge`,
    method: Method.POST,
    body: {
      participantIdList: {
        $type: [String, Array]
      },
      signatureList: {
        $type: Array
      },
      certId: {
        $type: String
      },
      certSN: {
        $type: String
      },
      isCompleted: {
        $type: Number
      },
      accountUid: {
        $type: String
      },
      source: {
        $type: String,
        $default: SOURCE
      }
    }
  }
};



// WEBPACK FOOTER //
// ./src/resource-api/api/batch.js